import { useEffect, useState } from "react";
import { adminOverview } from "@/lib/api";

export default function AdminOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { adminOverview().then(setData).catch(() => {}); }, []);
  const cards = [
    ["Users", data?.users], ["Orders", data?.orders], ["Open events", data?.open_events],
    ["Registrations", data?.registrations], ["Active members", data?.memberships],
    ["Leads", data?.leads], ["Packet issues", data?.packet_issues], ["Events", data?.events],
  ];
  return (
    <div data-testid="admin-overview">
      <p className="cv-kicker">Overview</p>
      <h1 className="cv-display text-3xl mt-4">The studio, at a glance.</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
        {cards.map(([label, val]) => (
          <div key={label} className="border border-[rgba(28,27,25,0.14)] rounded-[14px] p-5">
            <p className="cv-display text-3xl">{val ?? "--"}</p>
            <p className="cv-sans uppercase tracking-[0.12em] text-[0.68rem] text-[#1F1B16]/60 mt-2">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
